import { FormControl, MenuItem, type SelectChangeEvent, Select, InputLabel } from "@mui/material";
// import {
//   IntranetPortal_Departments_Dtos_DepartmentDto,
//   IntranetPortal_Designations_Dtos_ActiveDesignationDto,
//   IntranetPortal_Documents_Dtos_DocumentStatusOutputDto
// } from "../../services/intranet-portal-services";

// TODO: widht of the menu porps
interface Options {
  name: string;
  label: string;
  value: string | any;
  onChange?: (event: SelectChangeEvent<string>) => void;
  options?: any[];
  // options?: (IntranetPortal_Departments_Dtos_DepartmentDto | IntranetPortal_Designations_Dtos_ActiveDesignationDto)[];
  placeholder?: string;
  sx?: any;
  variant?: any;
}
export default function SelectOption(props: Options): React.ReactElement {
  const { name, label, value, onChange, options, sx } = props;

  return (
    <FormControl fullWidth size="small">
      <InputLabel sx={sx}>{label}</InputLabel>
      <Select
        data-testid={`custom-${name}-select`}
        fullWidth
        labelId={`${name}-select-label`}
        id={`${name}-select`}
        value={value}
        label={label}
        onChange={onChange}
        variant="outlined"
        name={name}
        sx={sx}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 250,
              maxWidth: 200, // this is static width (not good parctise?)
              scrollbarWidth: "thin"
            }
          }
        }}
      >
        {options?.map((item, index) => {
          return (
            <MenuItem
              data-testid="customOptionList"
              key={item.documents?.id ?? item.id ?? index}
              value={item.id}
            >
              {/* non uniformTpe so if Displayname then it will render displayname innot name */}
              {!item.displayName ? item.name : item.displayName}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
